import { rest } from 'msw'
export default [
  /**
   * お気に入り店舗登録
   */
  rest.post('/api/v2/set_myshop', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          shops: [
            {
              shopId: 1,
              shopCode: 1,
              shopName: '大崎1店',
            },
            {
              shopId: 2,
              shopCode: 2,
              shopName: '大崎2店',
            },
          ],
        },
      })
    )
  }),
  /**
   * お気に入り店舗一覧情報
   */
  rest.post('/api/v2/get_myshop', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          shops: [
            {
              shopId: 1,
              shopCode: 1,
              shopName: '大崎1店',
              shopUrl: 'https://www.google.com/',
              openDate: 915148799,
              closeDate: 915148799,
              enableSelect: 1,
            },
            {
              shopId: 2,
              shopCode: 2,
              shopName: '大崎2店',
              enableSelect: 1,
            },
          ],
          flyerSample:
            'https://static-stg.retailstudio.jp/assets/companies/7/flyer_sample.jpg',
          responseTime: '915148799',
        },
      })
    )
  }),
]
